import { Translation } from "..";

const es: Translation = {
  common: {
    save: "Guardar",
    cancel: "Cancelar",
    edit: "Editar",
    delete: "Eliminar",
    remove: "Quitar",
    submit: "Enviar",
    back: "Atrás",
    loading: "Cargando...",
    search: "Buscar",
    yes: "Sí",
    no: "No",
    close: "Cerrar",
    confirm: "Confirmar",
    actions: "Acciones",
    noData: "No hay datos disponibles",
    error: "Ha ocurrido un error",
    success: "Éxito",
    required: "Este campo es obligatorio",
    invalidUrl: "Introduce una URL válida",
    nonNegativeNumber: "Introduce un número entero mayor o igual a 0",
    optional: "Opcional",
    notSet: "No definido",
    descriptionHint:
      "Por favor, sea lo más detallado y exhaustivo posible. Incluya el contexto, los objetivos, el comportamiento esperado y cualquier restricción relevante.",
  },
  nav: {
    dashboard: "Panel",
    newRequest: "Nueva solicitud",
    requests: "Solicitudes",
    inventory: "Inventario",
    newInventory: "Nuevo elemento de inventario",
    users: "Usuarios",
    profile: "Perfil",
    admin: "Admin",
    language: "Idioma",
    help: "Ayuda",
    manual: "Manual de usuario",
    logout: "Cerrar sesión",
  },
  requests: {
    title: "Título",
    description: "Descripción",
    audience: "Audiencia",
    audienceInternal: "Interna",
    audienceInternalInfo:
      "Elige esta opción si la aplicación está destinada únicamente a los empleados de Rotoblaas. No será accesible desde fuera de la empresa.",
    audienceExternal: "Externa",
    audienceExternalInfo:
      "Elige esta opción si la aplicación será accesible para personas externas a Rotoblaas — por ejemplo, a través del sitio web, EService u otras herramientas públicas.",
    departments: "Departamentos",
    needsErpIntegration: "Necesita integración ERP",
    needsErpIntegrationInfo:
      "Selecciona esta opción si la aplicación necesitará intercambiar datos o integrarse con otros sistemas del grupo. Ejemplos: Semiramis, Pimcore, EService, CRM.",
    participants: "Participantes",
    participantsInfo: "Añade participantes a quienes quieres notificar sobre la creación de esta solicitud.",
    status: "Estado",
    statusDraft: "Borrador",
    statusNew: "Abierto",
    statusInProgress: "En curso",
    statusCompleted: "Completada",
    responsibleDepartment: "Departamento Responsable",
    responsibleDepartmentIntegrations: "Integraciones",
    responsibleDepartmentSoftwareDevelopment: "Desarrollo de software",
    responsibleDepartmentIct: "ICT",
    estimateDays: "Estimación (días)",
    internalNotes: "Notas internas",
    approvedBy: "Aprobado por",
    approvedAt: "Aprobado el",
    createdBy: "Creado por",
    createdAt: "Creado el",
    supervisor: "Supervisor",
    approve: "Aprobar",
    newRequest: "Nueva solicitud",
    viewRequestPageTitle: "Solicitud #{{id}}: {{title}}",
    editRequestPageTitle: "Editar: {{title}}",
    allRequests: "Todas las solicitudes",
    backToRequests: "Volver a las solicitudes",
    backToRequest: "Volver a la solicitud",
    filterAll: "Todas",
    filterDraft: "Borrador",
    filterNew: "Nuevas",
    filterInProgress: "En curso",
    filterCompleted: "Completadas",
    approveSuccess: "Solicitud aprobada con éxito",
    submitSuccess: "Solicitud enviada con éxito",
    updateSuccess: "Solicitud actualizada con éxito",
    managementSection: "Acciones de gestión",
    auditTrail: "Registro de auditoría",
    deleteRequest: "Eliminar solicitud",
    confirmDeleteRequest: "¿Estás seguro de que deseas eliminar esta solicitud? Esta acción no se puede deshacer.",
    deleteSuccess: "Solicitud eliminada con éxito",
    noRequests: "No se encontraron solicitudes",
    typeLabel: "Solicitud de funcionalidad",
  },
  inventory: {
    name: "Nombre",
    description: "Descripción",
    improvementNotes: "Notas de mejora",
    improvementNotesInfo:
      "Añade puntos de mejora, integraciones con ERP o cualquier cosa que no hayas podido gestionar de forma autónoma.",
    githubUrl: "URL de GitHub",
    deploymentLocation: "Ubicación de despliegue",
    deploymentLocationInfo: "¿Dónde está guardado o instalado el proyecto? Ej. SharePoint, servidor local…",
    audience: "Audiencia",
    audienceInternal: "Interna",
    audienceExternal: "Externa",
    participants: "Participantes",
    status: "Estado",
    statusUnderReview: "En evaluación",
    statusTakenOver: "Asumido",
    statusRejected: "Rechazado",
    statusCompleted: "Completada",
    rejectCause: "Causa de rechazo",
    rejectCauseNotInteresting: "No interesante",
    rejectCauseDuplicate: "Duplicado",
    rejectCauseNonCompliant: "No conforme",
    rejectCauseOutOfScope: "Fuera de alcance",
    rejectCauseInsufficientInfo: "Información insuficiente",
    rejectCauseNotSustainable: "No sostenible",
    rejectCauseOther: "Otro",
    rejectNote: "Nota de rechazo",
    attachments: "Archivos adjuntos",
    uploadAttachment: "Subir archivo adjunto",
    addAttachment: "Añadir archivo adjunto",
    noAttachments: "Sin archivos adjuntos",
    attachmentUploadFailed:
      "No se pudieron subir uno o más archivos adjuntos. El elemento no se guardó, inténtalo de nuevo.",
    createdBy: "Creado por",
    createdAt: "Creado el",
    newItem: "Nuevo elemento de inventario",
    allItems: "Todos los elementos",
    viewInventoryPageTitle: "Elemento #{{id}}: {{title}}",
    editInventoryPageTitle: "Editar elemento #{{id}}: {{title}}",
    backToInventory: "Volver al inventario",
    backToInventories: "Volver a los inventarios",
    audienceExternalAlert:
      "Los elementos destinados a una audiencia externa deben cumplir con las restricciones de HTML y JS. Asegúrese de que el código cumpla con los estándares web.",
    submitSuccess: "Elemento de inventario enviado con éxito",
    updateSuccess: "Elemento de inventario actualizado con éxito",
    managementSection: "Gestión",
    noItems: "No se encontraron elementos de inventario",
    filterAll: "Todos",
    filterUnderReview: "En evaluación",
    filterTakenOver: "Asumido",
    filterRejected: "Rechazado",
    filterCompleted: "Completada",
    fileSize: "Tamaño",
    uploadedBy: "Subido por",
    uploadedAt: "Subido el",
    deleteAttachment: "Eliminar archivo adjunto",
    confirmDeleteAttachment: "¿Está seguro de que desea eliminar este archivo adjunto?",
  },
  notifications: {
    title: "Notificaciones",
    markAllRead: "Marcar todo como leído",
    markAsRead: "Marcar como leído",
    noNotifications: "Sin notificaciones",
    unread: "no leídas",
    seeAll: "Ver todas las notificaciones",
    filterAll: "Todas",
    filterUnread: "No leídas",
    actions: {
      new_inventory_item: "añadió un nuevo elemento al inventario",
      request_approved: "aprobó una solicitud de desarrollo",
    },
  },
  profile: {
    language: "Idioma",
    manager: "Manager",
    noManager: "Ningún manager asignado",
    english: "English (UK)",
    usEnglish: "English (US)",
    italian: "Italiano",
    french: "Français",
    german: "Deutsch",
    spanish: "Español",
    saveLanguage: "Guardar idioma",
    languageSaved: "Idioma guardado",
    title: "Perfil de Usuario & Configuración",
    personalInfo: "Información Personal",
    languageSettings: "Configuración de Idioma",
  },
  dashboard: {
    welcome: "Bienvenido",
    allRequests: "Todas las solicitudes",
    allInventory: "Todos los elementos",
    myRequests: "Mis solicitudes",
    myInventory: "Mis elementos",
    recentNotifications: "Notificaciones recientes",
    createRequest: "Crear solicitud",
    createInventory: "Añadir elemento",
    statusNew: "Nueva",
    statusInProgress: "En curso",
    statusCompleted: "Completada",
    statusToApprove: "Por aprobar",
    total: "Total",
  },
  users: {
    allUsers: "Todos los usuarios",
    addUser: "Añadir usuario",
    name: "Nombre",
    firstName: "Nombre",
    lastName: "Apellido",
    email: "Correo electrónico",
    department: "Departamento",
    isAdmin: "Admin",
    lastAccess: "Último Acceso",
    noUsers: "No se encontraron usuarios",
    addUserSuccess: "Usuario añadido con éxito",
    userNotFound: "Usuario no encontrado",
    confirmDelete: "¿Estás seguro de que deseas eliminar este usuario?",
    roleAll: "Todos",
    roleAdmin: "Admin",
    roleNonAdmin: "No Admin",
    withAccess: "Con Acceso",
    withoutAccess: "Sin Acceso",
  },
  admin: {
    title: "Admin",
    users: "Usuarios",
    noAdminEndpoint: "Nota: la gestión de roles de usuario aún no está disponible a través de la API.",
    email: "Correo electrónico",
    name: "Nombre",
    isAdmin: "Admin",
    managerId: "ID del manager",
    createdAt: "Creado el",
  },
};

export default es;
